var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#6F42C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_701_379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8299 104L19.2305 48.7273H29.9989L39.9577 89.3452H40.4705L51.104 48.7273H60.9009L71.5614 89.3722H72.0472L82.006 48.7273H92.7745L77.1751 104H67.2972L56.2319 65.2173H55.8001L44.7077 104H34.8299ZM99.7173 104V48.7273H135.666V57.1207H109.73V72.1264H133.804V80.5199H109.73V95.6065H135.882V104H99.7173ZM145.881 104V48.7273H167.04C171.035 48.7273 174.354 49.357 176.999 50.6165C179.662 51.858 181.65 53.5582 182.964 55.7173C184.295 57.8764 184.961 60.3234 184.961 63.0582C184.961 65.3073 184.529 67.2325 183.665 68.8338C182.802 70.4171 181.641 71.7036 180.184 72.6932C178.727 73.6828 177.098 74.3935 175.299 74.8253V75.3651C177.26 75.473 179.14 76.0758 180.94 77.1733C182.757 78.2528 184.241 79.7822 185.393 81.7614C186.544 83.7405 187.12 86.1335 187.12 88.9403C187.12 91.8011 186.427 94.3741 185.042 96.6591C183.656 98.9261 181.569 100.716 178.781 102.03C175.992 103.343 172.483 104 168.255 104H145.881ZM155.894 95.6335H166.663C170.297 95.6335 172.915 94.9408 174.516 93.5554C176.136 92.152 176.945 90.3527 176.945 88.1577C176.945 86.5204 176.54 85.045 175.731 83.7315C174.921 82.4001 173.77 81.3565 172.276 80.6009C170.783 79.8272 169.002 79.4403 166.933 79.4403H155.894V95.6335ZM155.894 72.2344H165.799C167.526 72.2344 169.083 71.9195 170.468 71.2898C171.853 70.642 172.942 69.7334 173.734 68.5639C174.543 67.3764 174.948 65.973 174.948 64.3537C174.948 62.2126 174.192 60.4493 172.681 59.0639C171.188 57.6785 168.966 56.9858 166.015 56.9858H155.894V72.2344ZM195.831 48.7273H208.083L224.493 88.7784H225.14L241.549 48.7273H253.802V104H244.194V66.027H243.681L228.406 103.838H221.227L205.951 65.946H205.439V104H195.831V48.7273Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_379)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.833 352.773C315.408 351.796 320.677 351.959 325.295 353.037V244.496L210.447 277.476V403.513C210.508 404.205 210.549 404.917 210.549 405.609V405.629C210.549 422.597 192.747 439.443 170.775 443.247C148.822 447.031 131 436.35 131 419.362C131 402.394 148.822 385.549 170.775 381.764C179.035 380.34 186.725 380.971 193.093 383.209V228.058H194.049L342.67 194V368.805C342.934 370.086 343.077 371.389 343.077 372.691C343.077 372.691 343.077 372.691 343.077 372.711C343.077 386.891 328.184 400.97 309.853 404.124C291.502 407.298 276.63 398.366 276.63 384.186C276.61 370.005 291.482 355.926 309.833 352.773Z",
    fill: "#6F42C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_701_379",
    x: 7.23047,
    y: 48.7271,
    width: 250.572,
    height: 71.2729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_701_379"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_701_379",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212.056,
    height: 250,
    fill: "white",
    transform: "translate(131 194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebm);
export default __webpack_public_path__ + "static/media/webm.d542722a7b43bb0fa54d890907b5127f.svg";
export { ForwardRef as ReactComponent };